export default "__VITE_ASSET__a98943ac__"